var map = {
	"./locales/en-us/en.langs.js": "KW54",
	"./locales/zh-cn/zh.langs.js": "lqtI"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dzr9";


//////////////////
// WEBPACK FOOTER
// ./src/i18n ^\.\/locales\/([\s\S])+\.langs\.js$
// module id = dzr9
// module chunks = 12